/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-filename-extension */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "unorm";
import React from "react";
import { createRoot } from "react-dom/client";
import AppWrapper from "./App";

const values = require("object.values");

values.shim();

// React 18 rendering method
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppWrapper />);
